import React, { useState } from "react";
import { Button, Card, FormGroup, FormLabel } from "react-bootstrap";
import { ChevronRight, KeyFill } from "react-bootstrap-icons";
import {Campo, Formulario, TipoCampo} from "../Formulario"
import { useAuth } from "../../Auth";
import { useNavigate } from "react-router-dom";
export const Login: React.FC = () => {

	let auth=useAuth();
	let nav=useNavigate()
	if(auth.user){
		nav("/")
	}

	const [data,setData]=useState(new FormData());

	const submit = async (ev: any) => {
		auth.login(data.get("user")+"",data.get("password")+"","",(success:boolean)=>{
			//login ok
		})
	}

	const change = (ev: any) => {
		//validaciones
		let d = new FormData()
		data.forEach((val, key) => {
			d.set(key, val)
		})
		if (ev.target.targetElm) { //editor
			d.set(ev.target.targetElm.name, ev.target.getContent())
		}
		else if (ev.target.type !== "file") {
			d.set(ev.target.name, ev.target.value)
		}
		else {
			if (ev.target.files.length > 0)
				d.set(ev.target.name, ev.target.files[0])
			else
				d.delete(ev.target.name)
		}
		setData(d)
	}

	return <>
		<Card className="mt-4 m-auto" style={{ width: "20rem" }}>
			<Card.Header><KeyFill /> Ingreso al Gestor de Contenidos</Card.Header>
			<Card.Body>
				<Formulario submit={(ev:any)=>submit(ev)} change={(ev:any)=>{return change(ev)}} datos={data}>
					<FormGroup>
						<FormLabel>Nombre de Usuario</FormLabel>
						<Campo tipo={TipoCampo.Texto} nombre="user" required autofocus/>
					</FormGroup>
					<FormGroup>
						<FormLabel>Contraseña</FormLabel>
						<Campo tipo={TipoCampo.Password} nombre="password" required/>
					</FormGroup>
					<FormGroup className="mt-4 text-center">
						<Button type="submit" variant="dark"><ChevronRight/> Ingresar</Button>
					</FormGroup>
				</Formulario>
			</Card.Body>
		</Card>
	</>
}